export const basePath = "/invitation";
